import { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight, Phone, AlertTriangle } from "lucide-react";

// Static data matching the design - Comprehensive client list with realistic data
const staticClients = [
  {
    id: 1,
    name: "Emma Taylor",
    dateOfBirth: "27/05/1988",
    telephone: "+44 7965 123456",
    lastActivity: "20/04/2024, Botox - Upper Face",
    outstanding: null,
    hasAlert: true,
    alertText: "Allergy: Lidocaine",
    unpaidAmount: null,
    showActions: true,
  },
  {
    id: 2,
    name: "Sarah Thompson",
    dateOfBirth: "15/03/1990",
    telephone: "+44 7512 987654",
    lastActivity: "18/04/2024, Dermal Filler - Lips",
    outstanding: "Lip Filler Top-up",
    hasAlert: false,
    alertText: "",
    unpaidAmount: 120,
    showActions: true,
  },
  {
    id: 3,
    name: "James Mitchell",
    dateOfBirth: "22/09/1982",
    telephone: "+44 7701 456789",
    lastActivity: "15/04/2024, Laser Hair Removal",
    outstanding: null,
    hasAlert: true,
    alertText: "Allergy: Penicillin",
    unpaidAmount: null,
  },
  {
    id: 4,
    name: "Olivia Martinez",
    dateOfBirth: "08/12/1995",
    telephone: "+44 7823 654321",
    lastActivity: "12/04/2024, Chemical Peel",
    outstanding: null,
    hasAlert: false,
    alertText: "",
    unpaidAmount: null,
    showActions: true,
  },
  {
    id: 5,
    name: "William Brown",
    dateOfBirth: "14/06/1978",
    telephone: "+44 7934 789012",
    lastActivity: "No treatments yet",
    outstanding: null,
    hasAlert: false,
    alertText: "",
    unpaidAmount: null,
    showActions: true,
  },
  {
    id: 6,
    name: "Sophie Anderson",
    dateOfBirth: "30/01/1992",
    telephone: "+44 7645 321098",
    lastActivity: "08/04/2024, Microneedling",
    outstanding: "£85",
    hasAlert: false,
    alertText: "",
    unpaidAmount: null,
    showActions: true,
  },
  {
    id: 7,
    name: "David Wilson",
    dateOfBirth: "19/07/1985",
    telephone: "+44 7756 432109",
    lastActivity: "05/04/2024, PRP Facial",
    outstanding: null,
    hasAlert: true,
    alertText: "Allergy: Latex",
    unpaidAmount: 200,
    showActions: true,
  },
  {
    id: 8,
    name: "Isabella Johnson",
    dateOfBirth: "03/11/1997",
    telephone: "+44 7867 543210",
    lastActivity: "02/04/2024, Hydrafacial",
    outstanding: null,
    hasAlert: false,
    alertText: "",
    unpaidAmount: null,
  },
  {
    id: 9,
    name: "Michael Davis",
    dateOfBirth: "25/04/1980",
    telephone: "+44 7978 654321",
    lastActivity: "28/03/2024, Botox - Crow's Feet",
    outstanding: null,
    hasAlert: false,
    alertText: "",
    unpaidAmount: null,
  },
  {
    id: 10,
    name: "Charlotte Lee",
    dateOfBirth: "11/08/1993",
    telephone: "+44 7089 765432",
    lastActivity: "25/03/2024, Skin Tightening",
    outstanding: "£150",
    hasAlert: false,
    alertText: "",
    unpaidAmount: null,
    showActions: true,
  },
  {
    id: 11,
    name: "Alexander White",
    dateOfBirth: "07/02/1975",
    telephone: "+44 7190 876543",
    lastActivity: "22/03/2024, Laser Resurfacing",
    outstanding: null,
    hasAlert: true,
    alertText: "Allergy: Hyaluronic Acid",
    unpaidAmount: null,
  },
  {
    id: 12,
    name: "Amelia Harris",
    dateOfBirth: "16/05/1989",
    telephone: "+44 7201 987654",
    lastActivity: "18/03/2024, LED Light Therapy",
    outstanding: null,
    hasAlert: false,
    alertText: "",
    unpaidAmount: null,
  },
  {
    id: 13,
    name: "Benjamin Clark",
    dateOfBirth: "29/09/1983",
    telephone: "+44 7312 098765",
    lastActivity: "15/03/2024, Acne Treatment",
    outstanding: null,
    hasAlert: false,
    alertText: "",
    unpaidAmount: 95,
  },
  {
    id: 14,
    name: "Grace Turner",
    dateOfBirth: "21/12/1991",
    telephone: "+44 7423 109876",
    lastActivity: "10/03/2024, Dermal Filler - Cheeks",
    outstanding: null,
    hasAlert: false,
    alertText: "",
    unpaidAmount: null,
  },
  {
    id: 15,
    name: "Henry Roberts",
    dateOfBirth: "04/03/1972",
    telephone: "+44 7534 210987",
    lastActivity: "No treatments yet",
    outstanding: null,
    hasAlert: false,
    alertText: "",
    unpaidAmount: null,
    showActions: true,
  },
  {
    id: 16,
    name: "Lily Walker",
    dateOfBirth: "18/10/1994",
    telephone: "+44 7645 321098",
    lastActivity: "05/03/2024, Vitamin Injections",
    outstanding: null,
    hasAlert: false,
    alertText: "",
    unpaidAmount: null,
  },
  {
    id: 17,
    name: "Daniel Evans",
    dateOfBirth: "12/06/1987",
    telephone: "+44 7756 432109",
    lastActivity: "01/03/2024, Botox - Forehead",
    outstanding: null,
    hasAlert: false,
    alertText: "",
    unpaidAmount: null,
  },
  {
    id: 18,
    name: "Victoria King",
    dateOfBirth: "26/01/1996",
    telephone: "+44 7867 543210",
    lastActivity: "25/02/2024, Thread Lift",
    outstanding: "£320",
    hasAlert: true,
    alertText: "Allergy: Aspirin",
    unpaidAmount: null,
    showActions: true,
  },
  {
    id: 19,
    name: "Thomas Wright",
    dateOfBirth: "09/08/1979",
    telephone: "+44 7978 654321",
    lastActivity: "No treatments yet",
    outstanding: null,
    hasAlert: false,
    alertText: "",
    unpaidAmount: null,
    showActions: true,
  },
  {
    id: 20,
    name: "Emily Green",
    dateOfBirth: "14/04/1998",
    telephone: "+44 7089 765432",
    lastActivity: "20/02/2024, Lip Filler",
    outstanding: null,
    hasAlert: false,
    alertText: "",
    unpaidAmount: null,
  },
];

type TabType = "all" | "new" | "alerts" | "outstanding";

export default function ClientsList() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<TabType>("all");
  const [openActionsId, setOpenActionsId] = useState<number | null>(null);

  const tabs: { id: TabType; label: string }[] = [
    { id: "all", label: "All Clients" },
    { id: "new", label: "New Clients" },
    { id: "alerts", label: "With Alerts" },
    { id: "outstanding", label: "With Outstanding Balance" },
  ];

  // Filter clients based on active tab
  const filteredClients = useMemo(() => {
    switch (activeTab) {
      case "new":
        return staticClients.filter((c) => c.lastActivity.includes("No treatments"));
      case "alerts":
        return staticClients.filter((c) => c.hasAlert);
      case "outstanding":
        return staticClients.filter((c) => c.outstanding || c.unpaidAmount);
      default:
        return staticClients;
    }
  }, [activeTab]);

  const toggleActions = (id: number, e: React.MouseEvent) => {
    e.stopPropagation();
    setOpenActionsId(openActionsId === id ? null : id);
  };

  return (
    <div className="w-full min-h-screen bg-[#f8f5fc] p-6">
      {/* Tabs */}
      <div className="flex flex-wrap gap-3 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-5 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
              activeTab === tab.id
                ? "bg-[#704aaf] text-white"
                : "bg-white text-[#5c5c5c] hover:bg-[#f0ebf5]"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Table Container */}
      <div className="bg-white rounded-xl overflow-hidden border border-[#e8e0f0]">
        {/* Table */}
        <table className="w-full">
          {/* Table Header */}
          <thead>
            <tr className="bg-[#f3eff8] border-b border-[#e8e0f0]">
              <th className="text-left px-5 py-3.5 text-[13px] font-semibold text-[#6b5b7a] tracking-wide">
                Name
              </th>
              <th className="text-left px-5 py-3.5 text-[13px] font-semibold text-[#6b5b7a] tracking-wide">
                Date of Birth
              </th>
              <th className="text-left px-5 py-3.5 text-[13px] font-semibold text-[#6b5b7a] tracking-wide">
                Telephone
              </th>
              <th className="text-left px-5 py-3.5 text-[13px] font-semibold text-[#6b5b7a] tracking-wide">
                Last Activity
              </th>
              <th className="text-left px-5 py-3.5 text-[13px] font-semibold text-[#6b5b7a] tracking-wide">
                Outstanding
              </th>
              <th className="text-left px-5 py-3.5 text-[13px] font-semibold text-[#6b5b7a] tracking-wide">
                Actions
              </th>
              <th className="w-10"></th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {filteredClients.map((client) => (
              <tr
                key={client.id}
                onClick={() => navigate(`/aesthetics/clients/${client.id}`)}
                className="border-b border-[#f0ebf5] hover:bg-[#faf8fc] transition-colors cursor-pointer group"
              >
                {/* Name with Alert */}
                <td className="px-5 py-3.5">
                  <div className="flex items-center gap-2">
                    <span className="text-[14px] text-[#3d3d3d] font-medium">
                      {client.name}
                    </span>
                    {client.hasAlert && (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-medium bg-[#fff4e5] text-[#b86e00] border border-[#ffd89e]">
                        <AlertTriangle className="w-3 h-3" />
                        {client.alertText}
                      </span>
                    )}
                  </div>
                </td>

                {/* Date of Birth */}
                <td className="px-5 py-3.5 text-[14px] text-[#5c5c5c]">
                  {client.dateOfBirth || ""}
                </td>

                {/* Telephone */}
                <td className="px-5 py-3.5">
                  <div className="flex items-center gap-2 text-[14px] text-[#5c5c5c]">
                    <Phone className="w-4 h-4 text-[#8B6AAE]" />
                    <span>{client.telephone}</span>
                  </div>
                </td>

                {/* Last Activity */}
                <td className="px-5 py-3.5 text-[14px] text-[#5c5c5c]">
                  {client.lastActivity}
                </td>

                {/* Outstanding */}
                <td className="px-5 py-3.5">
                  {client.outstanding && (
                    <span className="text-[14px] font-medium text-[#3d3d3d]">
                      {client.outstanding}
                    </span>
                  )}
                  {client.unpaidAmount && (
                    <div className="flex flex-col">
                      <span className="text-[14px] font-medium text-[#3d3d3d]">
                        £ {client.unpaidAmount}
                      </span>
                      <span className="text-[10px] px-1.5 py-0.5 rounded bg-[#f0ebf5] text-[#8B6AAE] font-medium w-fit mt-0.5">
                        Unpaid
                      </span>
                    </div>
                  )}
                </td>

                {/* Actions */}
                <td className="px-5 py-3.5 relative">
                  {(client.showActions || client.outstanding) && (
                    <button
                      onClick={(e) => toggleActions(client.id, e)}
                      className="px-3.5 py-1.5 rounded text-[13px] font-medium bg-[#704aaf] text-white hover:bg-[#764BB7] transition-colors flex items-center gap-1"
                    >
                      Actions
                      <svg
                        className={`w-3 h-3 transition-transform ${openActionsId === client.id ? "rotate-180" : ""}`}
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                  )}
                  
                  {/* Dropdown */}
                  {openActionsId === client.id && (
                    <div className="absolute top-full left-5 mt-1 w-40 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-20">
                      <button className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-purple-50 transition-colors">
                        View Details
                      </button>
                      <button className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-purple-50 transition-colors">
                        Edit Client
                      </button>
                      <button className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-purple-50 transition-colors">
                        Book Appointment
                      </button>
                      <button className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 transition-colors">
                        Delete
                      </button>
                    </div>
                  )}
                </td>

                {/* Chevron */}
                <td className="pr-4 py-3.5">
                  <ChevronRight className="w-5 h-5 text-[#c4c4c4] group-hover:text-[#8B6AAE] transition-colors" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Click outside to close dropdown */}
      {openActionsId && (
        <div
          className="fixed inset-0 z-10"
          onClick={() => setOpenActionsId(null)}
        />
      )}
    </div>
  );
}
